// extracted by mini-css-extract-plugin
export default {"zakazTelegramList":"zakazTelegramList_zakazTelegramList__8Wtzi","zakazTelegramTitle":"zakazTelegramList_zakazTelegramTitle__CJ-wB"};